/* eslint no-nested-ternary: 0 */
import {
  Container,
  Dimmer,
  Dropdown,
  Grid,
  Loader,
  Label,
  Divider,
  Form,
  Header,
  Table,
  Segment,
  Button,
  Icon,
  Menu,
} from 'semantic-ui-react';

import qs from 'qs';
import { required, stringLength, matchRegex, identity as ValidateIdentity } from '@mhub/web-validations';
import clone from 'clone';
import { connect } from 'react-redux';
import { replace } from 'react-router-redux';
import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { flashSuccessMessage, flashErrorMessage, flashMessage } from '../../actions/flash';
import { fetchM } from '../../actions/fetchM';
import config from '../../../config';
import STATES from '../../constants/states';
import { SELECT_COUNTRIES } from '../../constants/countries';
import RESERVATION_LIMIT from '../../constants/reservationLimit';
import INTL_CALL_CODES from '../../constants/intlCallCodes';
import BU_STATUS_FILTER from '../../constants/businessUnitStatusFilter';
import { getCountryName } from '../../utils/countries';
import phone from '../../utils/validations/phone';
import NavBar from '../../components/NavBar';
import EditableBox from '../../components/EditableBox';
import AppForm from '../../components/AppForm';
import Phone from '../../components/Phone';
import Timestamp from '../../components/Timestamp';
import PhoneInput from '../../components/AppForm/PhoneInput';
import ProjectsList from '../modals/ProjectsList';
import ListItem from '../../components/ListItem';
import ChangeBranchToExternal from '../../containers/modals/ChangeBranchToExternal';
import AddBranchLogo from '../modals/AddBranchLogo';
import LoadImage from '../../components/LoadImage';
import TinFieldInput from '../../components/AppForm/TinFieldInput';
import { REGEX_TIN_VALID, REGEX_NPWP_ID } from '../../constants/regex';
import { getIdentityTypeOpts } from '../../utils/identityTypes';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';
import { translateModels } from '../../utils/translation';
import { GENERIC_TIN_UNMATCHED_ERROR_MSG, GENERIC_TIN_VALUES, getGenericTinByIdTypeAndTinNo, GOVERNMENT_GENERIC_TIN, isGenericTinFound } from '../../constants/tin';
import { IDENTITY_TYPE_BRN } from '../../constants/defaultIdentityTypeOpts';
import { routes } from './navigations';

const styles = {
  divider: { margin: '0.5em 0' },
  logo: { paddingLeft: '1rem', paddingBottom: '2rem' },
  buttons: { paddingLeft: '0' },
};

class Overview extends Component {

  static contextTypes = {
    store: PropTypes.object,
  }

  static propTypes = {
    routeParams: PropTypes.shape({
      id: PropTypes.string,
    }),
    location: PropTypes.shape({
      query: PropTypes.object,
      search: PropTypes.string,
      pathname: PropTypes.string,
    }),
    auth: PropTypes.shape({
      companyBranch: PropTypes.shape({
        id: PropTypes.number,
      }),
      isSuperAdmin: PropTypes.bool,
    }),
    t: PropTypes.func,
  }

  static mapStateToProps = state => ({
    auth: state.auth,
  })

  constructor(props) {
    super(props);
    const tinError = null;
    this.state = {
      token: null,
      loading: true,
      edit: false,
      data: null,
      oriData: null,
      branches: [],
      errMessages: [],
      tinMessage: null,
      showAddProject: false,
      showConfirmBranch: false,
      showAddCompanyLogo: false,
      showAddREALicenseLogo: false,
      confirmBranchModalType: {
        isProjectOwner: false,
        isHigherAccess: false,
      },
      tinError,
      tinRequired: false,
      tinEnabled: true,
    };
    this.validation = {
      name: createRef(),
      shortName: createRef(),
      department: createRef(),
      registrationNumber: createRef(),
      taxIdentificationNo: createRef(),
      referenceCode: createRef(),
      email: createRef(),
      phonePrefix: createRef(),
      website: createRef(),
      bankAccountName: createRef(),
      bankAccountNumber: createRef(),
      bankName: createRef(),
      citSSTRegisterationNumbery: createRef(),
      address1: createRef(),
      address2: createRef(),
      postcode: createRef(),
      city: createRef(),
      gps: createRef(),
      country: createRef(),
      invoiceTemplateNote: createRef(),
    };
  }
  componentDidMount() {
    const { store } = this.context;

    this.fetchBusinessUnit()
    .catch((err) => {
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage(err));
    });
    this.fetchUnitAllocatedCount();
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState.data !== this.state.data) {
      this.updateTinFieldState();
    }
  }
  getCoverPicture = (pictures) => {
    if (pictures && pictures.length > 0 && pictures.some(pp => pp.isCover === true)) {
      return pictures.find(pp => pp.isCover === true).picture;
    }
    return null;
  }
  getAccessStatus(value) {
    const status = BU_STATUS_FILTER.find(s => s.value === value);
    if (status) {
      return status.text;
    }
    return '';
  }
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, () => {
        res(state);
      });
    });
  }
  async getBranchLogoToken() {
    const { store } = this.context;
    let res;
    let token;
    try {
      res = await store.dispatch(fetchM('/company_branches/logos/', {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      return null;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      token = res.headers.get('X-Csrf-Token');
      // handle token.. etc
    }
    return token;
  }
  setLoading = (loading = false, loadingType = '') => new Promise((res) => {
    if (loadingType === 'validatingTIN') {
      this.setState({ validatingTin: loading }, res);
    } else {
      this.setState({ loading }, res);
    }
  })
  updateTinFieldState = () => {
    const { data } = this.state;
    let tinError = true;
    if (data && data.taxTinValidationStatus === 'success') {
      tinError = false;
    }
    if (this.state.tinError !== tinError) {
      this.setState({ tinError });
    }
  }
  async validateTIN(tinInput) {
    const { data } = this.state;
    if (!tinInput || !data.registrationNumber) {
      return;
    }
    const idType = getIdentityTypeOpts().find(i => i.value === IDENTITY_TYPE_BRN).tin_code;
    const query = Object.assign({
      tin: tinInput,
      idType,
      idValue: data.registrationNumber,
    });
    const { store } = this.context;
    try {
      const res = await store.dispatch(fetchM(`/tin/validate/?${qs.stringify(query)}`, {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
          'X-Origin': this.state.origin,
        },
      }));

      if (res && res.ok) {
        this.setState({
          tinError: false,
          tinMessage: null,
        });
      } else {
        const errorMessage = await res.text();
        this.setState({
          tinError: true,
          tinMessage: errorMessage,
        });
        return;
      }
    } catch (err) {
      if (err.res) {
        const errorMessage = await err.res.text();
        this.setState({
          tinError: true,
          tinMessage: errorMessage,
        });
      }
    }
  }
  handleTinInput = (e) => {
    const { auth } = this.props;
    const { data } = this.state;
    const isIndonesia = auth && auth.company && auth.company.countryCode.toUpperCase() === 'ID';

    if (isIndonesia) {
      data.taxIdentificationNo = e.target.value;
      this.setState({ data, tinError: false });
      return;
    }

    const tinInput = e.target.value;
    const isAlphanumeric = /^[a-zA-Z0-9]*$/.test(tinInput);

    if (isAlphanumeric) {
      data.taxIdentificationNo = tinInput;
      this.setState({ data, tinError: true });

      if (tinInput === '') {
        const updatedData = {
          ...data,
          taxIdentificationNo: '',
        };

        this.setState({ data: updatedData, tinError: false });
        return;
      }

      if (isAlphanumeric) {
        data.taxIdentificationNo = tinInput;
        this.setState({ data, tinError: true });

        // 1~2 letter followed by numeric with length 9 - 11
        const matched = REGEX_TIN_VALID.test(tinInput);
        const genericTin = getGenericTinByIdTypeAndTinNo(IDENTITY_TYPE_BRN, tinInput);
        this.setLoading(true, 'validatingTIN').then(() => {
          if (this.debounceTimeout) {
            clearTimeout(this.debounceTimeout);
          }
          this.debounceTimeout = setTimeout(() => {
            if (matched) {
              if (tinInput === GOVERNMENT_GENERIC_TIN) {
                this.setState({
                  tinError: false,
                  // tinFound: true,
                  tinMessage: null },
                () => {
                  this.setLoading(false, 'validatingTIN');
                });
              } else if (GENERIC_TIN_VALUES.includes(tinInput)) {
                this.setState({
                  tinError: !isGenericTinFound(genericTin),
                  // tinFound: isGenericTinFound(genericTin),
                  tinMessage: !isGenericTinFound(genericTin) ? GENERIC_TIN_UNMATCHED_ERROR_MSG : null },
                () => {
                  this.setLoading(false, 'validatingTIN');
                });
              } else {
                this.validateTIN(tinInput).finally(() => {
                  this.setLoading(false, 'validatingTIN');
                });
              }
            } else {
              this.setState({ tinError: true }, () => {
                this.setLoading(false, 'validatingTIN');
              });
            }
          }, 3000);
        });
      }
    }
  }
  handleOnChange = (event, value) => {
    const { data } = this.state;
    data[value.name] = value.value;
    this.setState({ data }, () => {
      // Validate TIN again on registrationNumber change.
      if (value.name === 'registrationNumber') {
        if (data.taxIdentificationNo !== '') {
          this.handleTinInput({ target: { value: data.taxIdentificationNo } });
        }
      }
    });
  }
  handleDetailOnChange = (event, value) => {
    const { data } = this.state;
    data.companyBranchDetail[value.name] = value.value;
    this.setState({ data });
  }
  handleOnCheck = (event, value) => {
    const { data } = this.state;
    data[value.name] = !data[value.name];
    if (value.name === 'viewAllProjects' && !data.viewAllProjects) {
      data.viewArchivedProjects = !data.isExternal;
      data.viewDraftProjects = !data.isExternal;
      data.viewReadyProjects = !data.isExternal;
    }
    this.setState({ data });
  }
  handleUserOnChange = (event, value) => {
    const { data } = this.state;
    data.user[value.name] = value.value;
    this.setState({ data });
  }
  handleCheckBoxChange = (event, d) => {
    const { data } = this.state;
    data[d.name] = !data[d.name];
    if (d.name === 'isExternal') {
      data.viewArchivedProjects = !data.isExternal;
      data.viewDraftProjects = !data.isExternal;
      data.viewReadyProjects = !data.isExternal;
    }
    this.setState({ data });
  }
  handleEditBusinessUnit = () => {
    this.setState({ edit: true });
  }
  handleUpdateBusinessUnit = () => {
    const { data, oriData } = this.state;
    const hasProjectOwnership = data.projects.find(p => p.maOwnerCompanyBranchID === data.id);
    const confirmBranchModalType = {
      isProjectOwner: false,
      isHigherAccess: false,
    };
    if ((oriData.isExternal === false && data.isExternal === true) && hasProjectOwnership) {
      confirmBranchModalType.isProjectOwner = true;
      confirmBranchModalType.isHigherAccess = true;
      this.setState({ showConfirmBranch: true, confirmBranchModalType });
      return;
    }
    if ((oriData.isExternal === false && data.isExternal === true) && !hasProjectOwnership) {
      confirmBranchModalType.isProjectOwner = false;
      confirmBranchModalType.isHigherAccess = true;
      this.setState({ showConfirmBranch: true, confirmBranchModalType });
      return;
    }
    this.updateBusinessUnit(data);
  }
  handleCancelChange = (e) => {
    e.preventDefault();
    this.setState({
      showConfirmBranch: false,
    });
  }
  handleConfirmChange = (e) => {
    e.preventDefault();
    this.setState({
      showConfirmBranch: false,
    }, () => {
      const { data } = this.state;
      this.updateBusinessUnit(data);
    });
  }
  handleResetChanges = () => {
    const { oriData } = this.state;
    this.setState({
      data: clone(oriData),
      edit: false,
    });
  }
  handleShowAddCompanyLogo = (e) => {
    e.preventDefault();
    this.setState({
      showAddCompanyLogo: true,
    });
  }
  handleShowAddREALicenseLogo = (e) => {
    e.preventDefault();
    this.setState({
      showAddREALicenseLogo: true,
    });
  }
  handleCloseAddCompanyLogo = (e) => {
    if (e) { e.preventDefault(); }
    this.setState({
      showAddCompanyLogo: false,
    });
  }
  handleCloseAddREALicenseLogo = (e) => {
    if (e) { e.preventDefault(); }
    this.setState({
      showAddREALicenseLogo: false,
    });
  }
  handleAddCompanyLogo = (e, selectedLogo, name) => {
    e.preventDefault();
    const { data } = this.state;
    data.companyBranchDetail.companyLogoID = selectedLogo.id;
    data.companyBranchDetail.companyLogo = selectedLogo;
    this.setState({ data });
  }
  handleAddREALicenseLogo = (e, selectedLogo, name) => {
    e.preventDefault();
    const { data } = this.state;
    data.companyBranchDetail.REALicenseLogoID = selectedLogo.id;
    data.companyBranchDetail.REALicenseLogo = selectedLogo;
    this.setState({ data });
  }
  handleUploadLogo = async body => ({
    url: '/company_branches/logos/',
    options: {
      credentials: 'include',
      method: 'POST',
      headers: {
        // Let browser decide Content-Type
        'X-Csrf-Token': await this.getBranchLogoToken(),
      },
      body,
    },
  })
  handleRemoveCompanyLogo = (e) => {
    e.preventDefault();
    const { data } = this.state;
    data.companyBranchDetail.companyLogoID = '';
    data.companyBranchDetail.companyLogo = null;
    this.setState({ data });
  }
  handleRemoveREALicenseLogo = (e) => {
    e.preventDefault();
    const { data } = this.state;
    data.companyBranchDetail.REALicenseLogoID = '';
    data.companyBranchDetail.REALicenseLogo = null;
    this.setState({ data });
  }
  handleCheckCompanyLogo = (logo) => {
    const { data } = this.state;
    return data.companyBranchDetail.companyLogoID === logo.id;
  }
  handleCheckREALicenseLogo = (logo) => {
    const { data } = this.state;
    return data.companyBranchDetail.REALicenseLogoID === logo.id;
  }
  updateBusinessUnit(data) {
    return AppForm.validate(this.validation, data)
      .then((validations) => {
        this.setState({
          errMessages: validations.filter(v => !v.isValid),
        });

        const updatedData = {
          ...data,
          taxTinValidationStatus: this.state.tinError === false ? 'success' : 'failed',
        };

        if (this.state.errMessages.length === 0 && this.state.tinRequired && updatedData.taxTinValidationStatus !== 'success') {
          const { store } = this.context;
          store.dispatch(flashMessage({
            header: 'Invalid TIN',
            message: 'Tax Identification Number is invalid',
            icon: 'warning sign',
            type: 'error',
            autoHideDuration: 5000,
          }));
          return;
        }
        this.putBusinessUnit(validations, updatedData)
        .catch((err) => {
          Bugsnag.notifyException(err);
        });
      });
  }
  async fetchBusinessUnit() {
    await this.setLoading(true);
    const { t } = this.props;
    const { store } = this.context;
    let res;
    try {
      res = await store.dispatch(fetchM(`${config.get('bookApiURL')}/company_branches/${this.props.routeParams.id}/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const token = res.headers.get('X-Csrf-Token');
      const data = await res.json();
      data.oriIsExternal = clone(data.isExternal);
      // handle token.. etc
      await this.setComponentState({
        token,
        data,
      });
      this.setState({
        oriData: clone(data),
      });
    }
    await this.setLoading(false);
  }
  async fetchUnitAllocatedCount() {
    await this.setLoading(true);
    const { store } = this.context;
    let res;
    try {
      res = await store.dispatch(fetchM(`${config.get('bookApiURL')}/company_branches/${this.props.routeParams.id}/total_unitAllocated/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const data = await res.json();
      if (data) {
        this.setState({ totalUnitAllocated: data });
      }
    }
    await this.setLoading(false);
  }
  async putBusinessUnit(validations, companyBranchData) {
    const { store } = this.context;
    const { t } = this.props;
    const companyBranch = Object.assign({}, companyBranchData);
    const errors = validations.filter(v => !v.isValid);
    if (errors.length > 0) {
      this.setState({ edit: true });
      store.dispatch(flashErrorMessage({ header: t('Please fix form errors', { ns: TRANSLATION_FILES.translation }), list: errors.map(l => l.message) }));
      return;
    }
    companyBranch.reservationLimit = parseInt(companyBranchData.reservationLimit, 10);
    let res;
    try {
      res = await store.dispatch(fetchM(`${config.get('bookApiURL')}/company_branches/${this.props.routeParams.id}/`, {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.state.token,
        },
        body: JSON.stringify(companyBranch),
      }));
    } catch (err) {
      Bugsnag.notifyException(err);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      store.dispatch(flashErrorMessage(err));
      return;
    }
    const data = await res.json();
    this.setState({ edit: false });
    this.fetchBusinessUnit();
    this.fetchUnitAllocatedCount();
    store.dispatch(flashSuccessMessage({ header: t('Update Success', { ns: TRANSLATION_FILES.translation }), message: `${t('{{name}} successfully updated', { ns: TRANSLATION_FILES.translation, name: data.name })}` }));
  }

  stateComponent() {
    let state;
    if (this.state.data.country.toUpperCase() === 'my'.toUpperCase()) {
      state = (<AppForm.Validate
        validation={[required]}
        ref={this.validation.state}
        onChange={this.handleOnChange}
        validateLabel="State"
      >
        <Form.Select
          fluid
          name="state"
          options={STATES}
          placeholder="Select state*"
          search
          selectOnBlur={false}
          value={this.state.data.state}
        />
      </AppForm.Validate>);
    } else {
      state = (<AppForm.Input
        autoComplete="off"
        fluid
        name="state"
        onChange={this.handleOnChange}
        placeholder="State*"
        ref={this.validation.state}
        validation={[required]}
        value={this.state.data.state}
        validateLabel="State"
      />);
    }
    return state;
  }
  handleMenu = (e, { value }) => {
    const { store } = this.context;
    if (value.includes(config.get('bookApiURL'))) {
      e.preventDefault();
      const winObj = window.open(value, '_blank');
      winObj.opener = null;
    } else {
      store.dispatch(replace(value));
    }
  }
  handleRemoveProject = (index) => {
    if (this.state.edit) {
      const { data } = this.state;
      data.projects.splice(index, 1);
      this.setState({ data });
    }
  }
  handleAddProject = (e, projects) => {
    e.preventDefault();
    const { data } = this.state;
    data.projects = projects;
    this.setState({
      data,
      showAddProject: false,
    });
  }
  handleShowAddProject = (e) => {
    e.preventDefault();
    this.setState({
      showAddProject: true,
    });
  }
  handleCloseAddProject = (e) => {
    if (e) { e.preventDefault(); }
    this.setState({
      showAddProject: false,
    });
  }
  checkProjectOwner = (project) => {
    if (project.maOwnerCompanyBranchID === this.state.data.id || 0) {
      return true;
    }
    return false;
  }
  render() {
    const { t, auth } = this.props;
    const { data } = this.state;
    const links = routes(this.props.routeParams.id);
    const { pathname } = this.props.location;
    const tinContent = (data && data.taxIdentificationNo) || this.state.tinRequired;
    const isIndonesia = auth && auth.company && auth.company.countryCode.toUpperCase() === 'ID';
    return (
      <Container>
        <ChangeBranchToExternal
          open={this.state.showConfirmBranch}
          onClose={this.handleCancelChange}
          onConfirm={this.handleConfirmChange}
          branchShortName={this.state.data ? this.state.data.shortName : ''}
          modalType={this.state.confirmBranchModalType}
        />
        <NavBar
          links={
            this.state.menuIsTab ?
              <Dropdown
                item
                selectOnBlur={false}
                options={links}
                onChange={this.handleMenu}
                value={pathname}
              />
            : links.map((link, key) => (
              <Menu.Item
                key={key}
                name={t(link.text)}
                active={pathname === link.value}
                onClick={e => this.handleMenu(e, link)}
              />
            ))
          }
        />
        <ProjectsList
          open={this.state.showAddProject}
          onClose={this.handleCloseAddProject}
          onConfirm={this.handleAddProject}
          onCheck={project => project.loanTrackerProjectID < 1}
          selected={data ? data.projects : []}
          companyBranchID={(data && data.id) || 0}
        />
        <Grid>
          <Grid.Row>
            <Grid.Column>
              <Dimmer active={this.state.loading} inverted>
                <Loader inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
              </Dimmer>
              <Divider horizontal>{t('Business Unit Information')}</Divider>
              {data ?
                <EditableBox
                  editable
                  isEditing={this.state.edit}
                  loading={this.state.loading}
                  onEdit={this.handleEditBusinessUnit}
                  onClick={this.handleUpdateBusinessUnit}
                  onCancel={this.handleResetChanges}
                  content={({ isEditing, onConfirm }) => (
                    <Grid>
                      <Grid.Row>
                        <Dimmer active={this.state.isEditing} inverted />
                        <Grid.Column mobile={16} tablet={16} computer={16}>
                          {
                            this.state.oriData ?
                              <Grid>
                                <Grid.Row stretched>
                                  <Grid.Column width={16}>
                                    <Header as="h2" textAlign="center">
                                      {this.state.oriData.shortName}
                                      {
                                        this.props.auth.companyBranch &&
                                        this.props.auth.companyBranch.id === this.state.oriData.id ?
                                          <Label size="small" pointing="left">{t('Your branch', { ns: TRANSLATION_FILES.screens })}</Label> : ''
                                      }
                                      {
                                        this.state.oriData.companyBranch ?
                                          <Header.Subheader>
                                            <i>{this.state.oriData.companyBranch.name}</i>
                                          </Header.Subheader> :
                                        null
                                      }
                                      <Header.Subheader>
                                        <i><Timestamp format="MMMM Do YYYY, h:mm a" timestamp={this.state.oriData.createdAt} /></i>
                                      </Header.Subheader>
                                    </Header>
                                  </Grid.Column>
                                  <Grid.Column width={16}>
                                    <Divider hidden className="tablet-hide" />
                                  </Grid.Column>
                                </Grid.Row>
                              </Grid> :
                            null
                          }
                          <Divider hidden className="large-hide small-hide" />
                        </Grid.Column>
                        <Grid.Column mobile={16} tablet={8} computer={8}>
                          <AppForm
                            onSubmit={onConfirm}
                            error={this.state.errMessages.length > 0}
                            ref={(ref) => { this.form = ref; }}
                          >
                            <Grid verticalAlign="middle">
                              <Grid.Column textAlign="left" width={8}>
                                <b>{translateModels(t, 'name', 'businessUnit')}*</b>
                              </Grid.Column>
                              <Grid.Column textAlign="right" width={8}>
                                {
                                  isEditing ?
                                    <AppForm.Input
                                      fluid
                                      name="name"
                                      onChange={this.handleOnChange}
                                      placeholder={translateModels(t, 'name', 'businessUnit')}
                                      value={data.name}
                                      ref={this.validation.name}
                                      validateLabel={translateModels(t, 'name', 'businessUnit')}
                                      validation={[required]}
                                    /> :
                                    data.name
                                }
                              </Grid.Column>
                            </Grid>
                            <Divider style={styles.divider} />
                            <Grid verticalAlign="middle">
                              <Grid.Column textAlign="left" width={8}>
                                <b>{translateModels(t, 'shortName', 'businessUnit')}*</b>
                              </Grid.Column>
                              <Grid.Column textAlign="right" width={8}>
                                {
                                  isEditing ?
                                    <AppForm.Input
                                      fluid
                                      name="shortName"
                                      onChange={this.handleOnChange}
                                      placeholder={translateModels(t, 'shortName', 'businessUnit')}
                                      value={data.shortName}
                                      ref={this.validation.shortName}
                                      validation={[required]}
                                      validateLabel={translateModels(t, 'shortName', 'businessUnit')}
                                    /> :
                                    data.shortName
                                }
                              </Grid.Column>
                            </Grid>
                            <Divider style={styles.divider} />
                            <Grid verticalAlign="middle">
                              <Grid.Column textAlign="left" width={8}>
                                <b>{translateModels(t, 'department', 'businessUnit')}</b>
                              </Grid.Column>
                              <Grid.Column textAlign="right" width={8}>
                                {
                                  isEditing ?
                                    <AppForm.Input
                                      fluid
                                      name="department"
                                      onChange={this.handleOnChange}
                                      placeholder={translateModels(t, 'department', 'businessUnit')}
                                      value={data.department}
                                      ref={this.validation.department}
                                    /> :
                                    data.department
                                }
                              </Grid.Column>
                            </Grid>
                            <Divider style={styles.divider} />
                            <Grid verticalAlign="middle">
                              <Grid.Column textAlign="left" width={8}>
                                <b>{translateModels(t, 'registrationNumber', 'businessUnit')}</b>
                              </Grid.Column>
                              <Grid.Column textAlign="right" width={8}>
                                {
                                  isEditing ?
                                    <AppForm.Input
                                      fluid
                                      name="registrationNumber"
                                      validateLabel={translateModels(t, 'registrationNumber', 'businessUnit')}
                                      required={tinContent}
                                      onChange={this.handleOnChange}
                                      placeholder={translateModels(t, 'registrationNumber', 'businessUnit')}
                                      value={data.registrationNumber}
                                      validation={tinContent ?
                                      [required,
                                        {
                                          validate: ValidateIdentity,
                                          option: {
                                            countryCode: 'MY',
                                            identityType: 'other',
                                          },
                                        },
                                      ] :
                                      [{
                                        validate: ValidateIdentity,
                                        option: {
                                          countryCode: 'MY',
                                          identityType: 'other',
                                        },
                                      }]}
                                      ref={this.validation.registrationNumber}
                                    /> :
                                    data.registrationNumber
                                }
                              </Grid.Column>
                            </Grid>
                            <Divider style={styles.divider} />
                            <Grid.Column mobile={16} tablet={8} computer={8}>
                              {
                                isEditing ?
                                  <Grid verticalAlign="middle">
                                    <Grid.Column textAlign="left" width={8}>
                                      <b>{isIndonesia ? 'NPWP' : 'Tax Identification Number'}</b>
                                    </Grid.Column>
                                    <Grid.Column textAlign="right" width={8}>
                                      <TinFieldInput
                                        hideLabel
                                        isIndonesia={isIndonesia}
                                        value={data.taxIdentificationNo}
                                        errMessage={this.state.tinMessage}
                                        isLoading={this.state.validatingTin}
                                        tinError={!isIndonesia && this.state.tinError}
                                        required={!isIndonesia && this.state.tinRequired}
                                        disabled={!this.state.tinEnabled}
                                        validation={!isIndonesia && this.state.tinRequired ?
                                        [required,
                                          {
                                            validate: matchRegex,
                                            option: {
                                              validRegex: REGEX_TIN_VALID,
                                            },
                                          },
                                        ] :
                                        [{
                                          validate: matchRegex,
                                          option: {
                                            validRegex: isIndonesia ? REGEX_NPWP_ID : REGEX_TIN_VALID,
                                          },
                                        }]}
                                        ref={this.validation.taxIdentificationNo}
                                        identityType={IDENTITY_TYPE_BRN}
                                        identityValue={data.registrationNumber}
                                        onChange={this.handleTinInput}
                                        identityType={4}
                                        identityValue={data.registrationNumber}
                                      />
                                    </Grid.Column>
                                  </Grid> :
                                  <Grid>
                                    <Grid.Column textAlign="left" width={6}>
                                      <b>{isIndonesia ? 'NPWP' : 'Tax Identification Number'}</b>
                                    </Grid.Column>
                                    <Grid.Column textAlign="right" width={10}>
                                      <span style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                        {data && data.taxIdentificationNo ? (
                                          <div>
                                            <Icon
                                              name={data.taxTinValidationStatus === 'success' ? 'check circle' : 'remove circle'}
                                              color={data.taxTinValidationStatus === 'success' ? 'green' : 'red'}
                                              style={{ marginLeft: '0.5em' }}
                                            />
                                            <i>{data.taxIdentificationNo}</i>
                                          </div>
                                        ) : (
                                          '-'
                                        )}
                                      </span>
                                    </Grid.Column>
                                  </Grid>
                              }
                            </Grid.Column>
                            <Divider style={styles.divider} />
                            <Grid verticalAlign="middle">
                              <Grid.Column textAlign="left" width={8}>
                                <b>{translateModels(t, 'referenceCode', 'businessUnit')}</b>
                              </Grid.Column>
                              <Grid.Column textAlign="right" width={8}>
                                {
                                  isEditing ?
                                    <AppForm.Input
                                      fluid
                                      name="referenceCode"
                                      onChange={this.handleOnChange}
                                      placeholder={translateModels(t, 'referenceCode', 'businessUnit')}
                                      value={data.referenceCode}
                                      ref={this.validation.referenceCode}
                                    /> :
                                    data.referenceCode
                                }
                              </Grid.Column>
                            </Grid>
                            <Divider style={styles.divider} />
                            <Grid verticalAlign="middle">
                              <Grid.Column textAlign="left" width={8}>
                                <b>{t('Email')}</b>
                              </Grid.Column>
                              <Grid.Column textAlign="right" width={8}>
                                {
                                  isEditing ?
                                    <AppForm.Input
                                      fluid
                                      name="email"
                                      onChange={this.handleOnChange}
                                      type="email"
                                      placeholder={t('Email')}
                                      value={data.email}
                                      ref={this.validation.email}
                                      validateLabel={t('Email')}
                                    /> :
                                    <a href={`mailto:${data.email}`}>
                                      {data.email}
                                    </a>
                                }
                              </Grid.Column>
                            </Grid>
                            <Divider style={styles.divider} />
                            <Grid>
                              <Grid.Column textAlign="left" width={4}>
                                <b>{t('Phone')}</b>
                              </Grid.Column>
                              <Grid.Column textAlign="right" width={12}>
                                {
                                  isEditing ?
                                    <Grid className="compact">
                                      <Grid.Column width={16}>
                                        <AppForm.Validate
                                          validation={data.phone !== '' ? [required] : null}
                                          ref={this.validation.phonePrefix}
                                          onChange={this.handleOnChange}
                                          validateLabel={t('Phone prefix')}
                                        >
                                          <Form.Select
                                            name="phonePrefix"
                                            value={data.phonePrefix}
                                            search
                                            options={INTL_CALL_CODES}
                                            noResultsMessage={t('No results found', { ns: TRANSLATION_FILES.translation })}
                                          />
                                        </AppForm.Validate>
                                      </Grid.Column>
                                      <Grid.Column width={16}>
                                        <PhoneInput
                                          fluid
                                          name="phone"
                                          onChange={this.handleOnChange}
                                          prefix={data.phonePrefix}
                                          type="tel"
                                          placeholder={t('Phone Number')}
                                          value={data.phone}
                                          validation={[phone]}
                                        />
                                      </Grid.Column>
                                    </Grid>
                                : <Phone
                                  mobilePrefix={data.phonePrefix}
                                  mobile={data.phone}
                                />
                                }
                              </Grid.Column>
                            </Grid>
                            <Divider style={styles.divider} />
                            <Grid verticalAlign="middle">
                              <Grid.Column textAlign="left" width={8}>
                                <b>{t('Website')}</b>
                              </Grid.Column>
                              <Grid.Column textAlign="right" width={8}>
                                {
                                  isEditing ?
                                    <AppForm.Input
                                      fluid
                                      name="website"
                                      onChange={this.handleDetailOnChange}
                                      placeholder={t('Website')}
                                      value={data.companyBranchDetail.website}
                                      ref={this.validation.website}
                                    /> :
                                    data.companyBranchDetail.website
                                }
                              </Grid.Column>
                            </Grid>
                            <Divider style={styles.divider} />
                            <Grid verticalAlign="middle">
                              <Grid.Column textAlign="left" width={8}>
                                <b>{translateModels(t, 'bankAccountName', 'businessUnit')}</b>
                              </Grid.Column>
                              <Grid.Column textAlign="right" width={8}>
                                {
                                  isEditing ?
                                    <AppForm.Input
                                      fluid
                                      name="bankAccountName"
                                      onChange={this.handleDetailOnChange}
                                      placeholder={translateModels(t, 'bankAccountName', 'businessUnit')}
                                      value={data.companyBranchDetail.bankAccountName}
                                      ref={this.validation.bankAccountName}
                                    /> :
                                    data.companyBranchDetail.bankAccountName
                                }
                              </Grid.Column>
                            </Grid>
                            <Divider style={styles.divider} />
                            <Grid verticalAlign="middle">
                              <Grid.Column textAlign="left" width={8}>
                                <b>{translateModels(t, 'bankAccountNumber', 'businessUnit')}</b>
                              </Grid.Column>
                              <Grid.Column textAlign="right" width={8}>
                                {
                                  isEditing ?
                                    <AppForm.Input
                                      fluid
                                      name="bankAccountNumber"
                                      onChange={this.handleDetailOnChange}
                                      placeholder={translateModels(t, 'bankAccountNumber', 'businessUnit')}
                                      value={data.companyBranchDetail.bankAccountNumber}
                                      ref={this.validation.bankAccountNumber}
                                    /> :
                                    data.companyBranchDetail.bankAccountNumber
                                }
                              </Grid.Column>
                            </Grid>
                            <Divider style={styles.divider} />
                            <Grid verticalAlign="middle">
                              <Grid.Column textAlign="left" width={8}>
                                <b>{translateModels(t, 'bankName', 'businessUnit')}</b>
                              </Grid.Column>
                              <Grid.Column textAlign="right" width={8}>
                                {
                                  isEditing ?
                                    <AppForm.Input
                                      fluid
                                      name="bankName"
                                      onChange={this.handleDetailOnChange}
                                      placeholder={translateModels(t, 'bankName', 'businessUnit')}
                                      value={data.companyBranchDetail.bankName}
                                      ref={this.validation.bankName}
                                    /> :
                                    data.companyBranchDetail.bankName
                                }
                              </Grid.Column>
                            </Grid>
                            <Divider style={styles.divider} />
                            <Grid verticalAlign="middle">
                              <Grid.Column textAlign="left" width={8}>
                                <b>{translateModels(t, 'SSTRegisterationNumber', 'businessUnit')}</b>
                              </Grid.Column>
                              <Grid.Column textAlign="right" width={8}>
                                {
                                  isEditing ?
                                    <AppForm.Input
                                      fluid
                                      name="SSTRegisterationNumber"
                                      onChange={this.handleDetailOnChange}
                                      placeholder={translateModels(t, 'SSTRegisterationNumber', 'businessUnit')}
                                      value={data.companyBranchDetail.SSTRegisterationNumber}
                                      ref={this.validation.SSTRegisterationNumber}
                                    /> :
                                    data.companyBranchDetail.SSTRegisterationNumber
                                }
                              </Grid.Column>
                            </Grid>
                            <Divider style={styles.divider} />
                            <Grid>
                              <Grid.Column textAlign="left" width={4}>
                                <b>{t('Projects')}</b>
                              </Grid.Column>
                              <Grid.Column textAlign="right" width={12}>
                                <Form.Checkbox
                                  label={t('View all projects')}
                                  name="viewAllProjects"
                                  checked={data.viewAllProjects}
                                  onChange={this.handleOnCheck}
                                  disabled={!isEditing}
                                />
                              </Grid.Column>
                              <Grid.Column textAlign="right" width={16} style={{ paddingTop: '0' }}>
                                <Form.Checkbox
                                  label={t('View archived projects')}
                                  name="viewArchivedProjects"
                                  checked={data.viewArchivedProjects}
                                  onChange={this.handleOnCheck}
                                  disabled={!isEditing || !data.viewAllProjects}
                                />
                              </Grid.Column>
                              <Grid.Column textAlign="right" width={16} style={{ paddingTop: '0' }}>
                                <Form.Checkbox
                                  label={t('View draft projects')}
                                  name="viewDraftProjects"
                                  checked={data.viewDraftProjects}
                                  onChange={this.handleOnCheck}
                                  disabled={!isEditing || !data.viewAllProjects}
                                />
                              </Grid.Column>
                              <Grid.Column textAlign="right" width={16} style={{ paddingTop: '0' }}>
                                <Form.Checkbox
                                  label={t('View ready projects')}
                                  name="viewReadyProjects"
                                  checked={data.viewReadyProjects}
                                  onChange={this.handleOnCheck}
                                  disabled={!isEditing || !data.viewAllProjects}
                                />
                              </Grid.Column>
                            </Grid>
                            <Divider style={styles.divider} />
                            <Grid verticalAlign="middle">
                              <Grid.Column textAlign="left" width={8}>
                                <b>{t('Agency')}</b>
                              </Grid.Column>
                              <Grid.Column textAlign="right" width={8}>
                                {
                                  isEditing ?
                                    <Form.Checkbox
                                      label={t('Agency')}
                                      name="isExternal"
                                      disabled={!this.props.auth.isSuperAdmin && data.oriIsExternal}
                                      checked={data.isExternal}
                                      onChange={this.handleCheckBoxChange}
                                    /> :
                                      data.isExternal ? t('Yes') : t('No')
                                }
                              </Grid.Column>
                            </Grid>
                            <Divider style={styles.divider} className="large-hide small-hide tablet-hide" />
                          </AppForm>
                        </Grid.Column>
                        <Grid.Column mobile={16} tablet={8} computer={8}>
                          <AppForm
                            onSubmit={onConfirm}
                            error={this.state.errMessages.length > 0}
                            ref={(ref) => { this.form = ref; }}
                          >
                            <Grid>
                              <Grid.Column textAlign="left" width={8}>
                                <b>{translateModels(t, 'reservationLimit', 'businessUnit')}</b>
                              </Grid.Column>
                              <Grid.Column textAlign="right" width={8}>
                                {
                                  isEditing ?
                                    <Form.Select
                                      autoComplete="off"
                                      fluid
                                      name="reservationLimit"
                                      options={RESERVATION_LIMIT.map(option => ({
                                        ...option,
                                        text: option.text === 'Unlimited' ? t('Unlimited', { ns: TRANSLATION_FILES.constants }) : option.text,
                                      }))}
                                      placeholder={translateModels(t, 'Select Limit', 'businessUnit')}
                                      search
                                      selectOnBlur={false}
                                      value={data.reservationLimit >= 0 ? `${data.reservationLimit}` : ''}
                                      onChange={this.handleOnChange}
                                      noResultsMessage={t('No results found', { ns: TRANSLATION_FILES.translation })}
                                    />
                                  :
                                    data.reservationLimit === 0 ? t('Unlimited', { ns: TRANSLATION_FILES.constants }) : data.reservationLimit
                                }
                              </Grid.Column>
                            </Grid>
                            <Divider style={styles.divider} />
                            <Grid>
                              <Grid.Column textAlign="left" width={8}>
                                <b>{t('Access')}</b>
                              </Grid.Column>
                              <Grid.Column textAlign="right" width={8}>
                                {
                                  isEditing ?
                                    <Form.Select
                                      autoComplete="off"
                                      fluid
                                      name="statusID"
                                      options={BU_STATUS_FILTER.map(status => ({
                                        ...status,
                                        text: t(status.text),
                                      }))}
                                      placeholder={t('Select Access')}
                                      selectOnBlur={false}
                                      value={data.statusID}
                                      onChange={this.handleOnChange}
                                    />
                                  :
                                    t(this.getAccessStatus(data.statusID))
                                }
                              </Grid.Column>
                            </Grid>
                            <Divider style={styles.divider} />
                            <Grid>
                              {
                                !isEditing ?
                                  <Grid.Column textAlign="left" width={4}>
                                    <b>{t('Address')} 1</b>
                                  </Grid.Column> :
                                null
                              }
                              <Grid.Column textAlign={isEditing ? 'left' : 'right'} width={isEditing ? 16 : 12}>
                                {
                                  isEditing ?
                                    <AppForm.Input
                                      autoComplete="off"
                                      label={`${t('Address')} 1*`}
                                      name="address1"
                                      onChange={this.handleOnChange}
                                      placeholder={`${t('Address')} 1*`}
                                      ref={this.validation.address1}
                                      validation={[required, {
                                        validate: stringLength,
                                        option: {
                                          max: 256,
                                        },
                                      }]}
                                      value={data.address1}
                                      validateLabel={`${t('Address')} 1`}
                                    />
                                : data.address1
                                }
                              </Grid.Column>
                            </Grid>
                            <Divider style={styles.divider} />
                            <Grid>
                              {
                                !isEditing ?
                                  <Grid.Column textAlign="left" width={4}>
                                    <b>{t('Address')} 2</b>
                                  </Grid.Column> :
                                null
                              }
                              <Grid.Column textAlign={isEditing ? 'left' : 'right'} width={isEditing ? 16 : 12}>
                                {
                                  isEditing ?
                                    <AppForm.Input
                                      autoComplete="off"
                                      label={`${t('Address')} 2`}
                                      name="address2"
                                      onChange={this.handleOnChange}
                                      placeholder={`${t('Address')} 2`}
                                      ref={this.validation.address2}
                                      value={data.address2}
                                      validateLabel={`${t('Address')} 2`}
                                      validation={[{
                                        validate: stringLength,
                                        option: {
                                          max: 256,
                                        },
                                      }]}
                                    />
                                  : data.address2
                                }
                              </Grid.Column>
                            </Grid>
                            <Divider style={styles.divider} />
                            <Grid>
                              <Grid.Column textAlign="left" width={8}>
                                <b>{t('Postcode')}*</b>
                              </Grid.Column>
                              <Grid.Column textAlign="right" width={8}>
                                {
                                  isEditing ?
                                    <AppForm.Input
                                      autoComplete="off"
                                      name="postcode"
                                      onChange={this.handleOnChange}
                                      placeholder={`${t('Postcode')}*`}
                                      value={data.postcode}
                                      type="tel"
                                      ref={this.validation.postcode}
                                      validation={[required]}
                                      validateLabel={t('Postcode')}
                                    />
                                  : data.postcode
                                }
                              </Grid.Column>
                            </Grid>
                            <Divider style={styles.divider} />
                            <Grid>
                              <Grid.Column textAlign="left" width={8}>
                                <b>{t('City')}*</b>
                              </Grid.Column>
                              <Grid.Column textAlign="right" width={8}>
                                {
                                  isEditing ?
                                    <AppForm.Input
                                      autoComplete="off"
                                      name="city"
                                      onChange={this.handleOnChange}
                                      placeholder={`${t('City')}*`}
                                      value={data.city}
                                      ref={this.validation.city}
                                      validation={[required]}
                                      validateLabel={t('City')}
                                    />
                                  : data.city
                                }
                              </Grid.Column>
                            </Grid>
                            <Divider style={styles.divider} />
                            <Grid>
                              <Grid.Column textAlign="left" width={8}>
                                <b>{t('State')}*</b>
                              </Grid.Column>
                              <Grid.Column textAlign="right" width={8}>
                                {
                                  isEditing ?
                                  this.stateComponent()
                                  : data.state
                                }
                              </Grid.Column>
                            </Grid>
                            <Divider style={styles.divider} />
                            <Grid>
                              <Grid.Column textAlign="left" width={8}>
                                <b>{t('Country')}*</b>
                              </Grid.Column>
                              <Grid.Column textAlign="right" width={8}>
                                {
                                  isEditing ?
                                    <AppForm.Validate
                                      validation={[required]}
                                      ref={this.validation.country}
                                      onChange={(e, d) => {
                                        // Reset state input field
                                        data.state = '';
                                        this.setState({ data });
                                        this.handleOnChange(e, d);
                                      }}
                                      validateLabel={t('Country')}
                                    >
                                      <Form.Select
                                        autoComplete="off"
                                        fluid
                                        name="country"
                                        options={SELECT_COUNTRIES}
                                        placeholder={`${t('Select Country')}*`}
                                        search
                                        selectOnBlur={false}
                                        value={data.country}
                                        noResultsMessage={t('No results found', { ns: TRANSLATION_FILES.translation })}
                                      />
                                    </AppForm.Validate>
                                  : getCountryName(data.country)
                                }
                              </Grid.Column>
                            </Grid>
                            {
                              data.gps ?
                                <div>
                                  <Divider style={styles.divider} />
                                  <Grid>
                                    <Grid.Column textAlign="left" width={8}>
                                      <b>{t('GPS Coordinates')}*</b>
                                    </Grid.Column>
                                    <Grid.Column textAlign="right" width={8}>
                                      {
                                        isEditing ?
                                          <AppForm.Input
                                            autoComplete="off"
                                            name="gps"
                                            onChange={this.handleOnChange}
                                            placeholder={`${t('GPS Coordinates')}*`}
                                            value={data.gps}
                                            ref={this.validation.gps}
                                            validation={[required]}
                                            validateLabel={`${t('GPS Coordinates')}*`}
                                          />
                                        : data.gps
                                      }
                                    </Grid.Column>
                                  </Grid>
                                </div> :
                              null
                            }
                            <Divider style={styles.divider} />
                            <Grid verticalAlign="middle">
                              <Grid.Column textAlign="left" width={8}>
                                <b>{t('Company logo')}</b>
                              </Grid.Column>
                              <Grid.Row style={styles.logo}>
                                {data.companyBranchDetail.companyLogo && data.companyBranchDetail.companyLogo.key ?
                                  <Segment>
                                    <Grid.Column mobile={16}>
                                      <LoadImage
                                        picture={data.companyBranchDetail.companyLogo}
                                        pictureSize={50}
                                        extension="png"
                                      />
                                    </Grid.Column>
                                  </Segment>
                                  : null}
                                {
                                isEditing ?
                                  <Grid.Column mobile={16} style={styles.buttons}>
                                    <Button
                                      onClick={this.handleShowAddCompanyLogo}
                                      disabled={this.state.loading}
                                      primary
                                      icon="add"
                                      content={data.companyBranchDetail.companyLogoID ? t('Replace', { ns: TRANSLATION_FILES.screens }) : t('Add', { ns: TRANSLATION_FILES.screens })}
                                    />
                                    {data.companyBranchDetail.companyLogoID ?
                                      <Button
                                        onClick={this.handleRemoveCompanyLogo}
                                        disabled={this.state.loading}
                                        negative
                                        primary
                                        icon="remove"
                                        content={t('Remove', { ns: TRANSLATION_FILES.screens })}
                                      />
                                      : null
                                    }
                                  </Grid.Column>
                                  : null
                              }
                              </Grid.Row>
                            </Grid>
                            <Divider style={styles.divider} />
                            <Grid verticalAlign="middle">
                              <Grid.Column textAlign="left" width={8}>
                                <b>{translateModels(t, 'reaLicenseLogo', 'businessUnit')}</b>
                              </Grid.Column>
                              <Grid.Row style={styles.logo}>
                                {data.companyBranchDetail.REALicenseLogo && data.companyBranchDetail.REALicenseLogo.key ?
                                  <Segment>
                                    <Grid.Column mobile={16}>
                                      <LoadImage
                                        picture={data.companyBranchDetail.REALicenseLogo}
                                        pictureSize={50}
                                        extension="png"
                                      />
                                    </Grid.Column>
                                  </Segment>
                                  : null}
                                {
                                  isEditing ?
                                    <Grid.Column mobile={16} style={styles.buttons}>
                                      <Button
                                        onClick={this.handleShowAddREALicenseLogo}
                                        disabled={this.state.loading}
                                        primary
                                        icon="add"
                                        content={data.companyBranchDetail.REALicenseLogoID ? t('Replace', { ns: TRANSLATION_FILES.screens }) : t('Add', { ns: TRANSLATION_FILES.screens })}
                                      />
                                      {data.companyBranchDetail.REALicenseLogoID ?
                                        <Button
                                          onClick={this.handleRemoveREALicenseLogo}
                                          disabled={this.state.loading}
                                          negative
                                          primary
                                          icon="remove"
                                          content={t('Remove', { ns: TRANSLATION_FILES.screens })}
                                        />
                                      : null
                                    }
                                    </Grid.Column>
                                  : null
                                }
                              </Grid.Row>
                            </Grid>
                            <AddBranchLogo
                              ref={(ref) => { this.logoModal = ref; }}
                              open={this.state.showAddCompanyLogo}
                              onClose={this.handleCloseAddCompanyLogo}
                              onConfirm={this.handleAddCompanyLogo}
                              onUpload={this.handleUploadLogo}
                              onCheck={this.handleCheckCompanyLogo}
                            />
                            <AddBranchLogo
                              ref={(ref) => { this.logoModal = ref; }}
                              open={this.state.showAddREALicenseLogo}
                              onClose={this.handleCloseAddREALicenseLogo}
                              onConfirm={this.handleAddREALicenseLogo}
                              onUpload={this.handleUploadLogo}
                              onCheck={this.handleCheckREALicenseLogo}
                            />
                            <Divider style={styles.divider} />
                            <Grid>
                              {
                                !isEditing ?
                                  <Grid.Column textAlign="left" width={8}>
                                    <b>{translateModels(t, 'invoiceTemplateNote', 'businessUnit')}</b>
                                  </Grid.Column> :
                                null
                              }
                              <Grid.Column textAlign={isEditing ? 'left' : 'right'} width={isEditing ? 16 : 8}>
                                {
                                  isEditing ?
                                    <AppForm.Input
                                      fluid
                                      name="invoiceTemplateNote"
                                      label={translateModels(t, 'invoiceTemplateNote', 'businessUnit')}
                                      onChange={this.handleDetailOnChange}
                                      placeholder={translateModels(t, 'For e.g. Please email to address@email.com upon payment', 'businessUnit')}
                                      value={data.companyBranchDetail.invoiceTemplateNote}
                                      ref={this.validation.invoiceTemplateNote}
                                    /> :
                                    data.companyBranchDetail.invoiceTemplateNote
                                }
                              </Grid.Column>
                            </Grid>
                          </AppForm>
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                    )}
                />
                  : ''
              }
            </Grid.Column>
          </Grid.Row>
          {
            data && !data.viewAllProjects ? (
              <Grid.Row>
                <Grid.Column>
                  <Divider horizontal>{t('Projects', { ns: TRANSLATION_FILES.screens })}</Divider>
                  {
                    data.projects && data.projects.length > 0 ? (
                      <Table unstackable>
                        <Table.Body>
                          {
                            data.projects.map((project, idx) => (
                              <Table.Row key={idx}>
                                <Table.Cell>
                                  <ListItem
                                    item={project}
                                    totalCountUnitAllocated={this.state.totalUnitAllocated ? this.state.totalUnitAllocated.find(unit => unit.projectID === project.id) : null}
                                    header={(item) => {
                                      if (this.checkProjectOwner(project)) {
                                        return <span>{item.name} <Icon name="lock" fitted /><i> <small>{t('Owner', { ns: TRANSLATION_FILES.translation })}</small></i></span>;
                                      }
                                      return item.name;
                                    }}
                                    subheader={item => t(item.status.name, { ns: TRANSLATION_FILES.constants })}
                                    rightComponent={
                                      this.state.edit ?
                                        <div>
                                          <Button
                                            type="button"
                                            compact
                                            negative
                                            size="mini"
                                            icon="remove"
                                            onClick={() => this.handleRemoveProject(idx)}
                                            disabled={
                                            !this.state.edit ||
                                            this.checkProjectOwner(project)
                                          }
                                          />
                                        </div>
                                      : null
                                    }
                                  />
                                </Table.Cell>
                              </Table.Row>
                            ))
                          }
                        </Table.Body>
                      </Table>
                    ) : (
                      <Segment textAlign="center">
                        {
                          this.state.loading ?
                            <Loader active inline="centered">Loading</Loader>
                          : t('No projects found', { ns: TRANSLATION_FILES.screens })
                        }
                      </Segment>
                    )
                  }
                </Grid.Column>
              </Grid.Row>
            ) : null
          }
          {
            (data && !data.viewAllProjects) && this.state.edit ? (
              <Grid.Row>
                <Grid.Column textAlign="center">
                  <Button
                    content={t('Add project', { ns: TRANSLATION_FILES.screens })}
                    onClick={this.handleShowAddProject}
                  />
                </Grid.Column>
              </Grid.Row>
            ) : null
          }
        </Grid>
      </Container>
    );
  }
}

export default withTranslation([
  ...namespaces,
  TRANSLATION_FILES.models.businessUnit,
])(connect(Overview.mapStateToProps)(Overview));



// WEBPACK FOOTER //
// ./src/containers/BusinessUnits/Overview.jsx